



































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';
import { namespace } from 'vuex-class';
import { complexClone } from '@acgn/herm/src/util/serialize';

const StatisticAction = namespace('desk/statistic').Action;
const StatisticGetter = namespace('desk/statistic').Getter;

const CommGetter = namespace('desk/comm').Getter;

export interface TargetEditType { // 编辑结构类型
  num: number | null; // 预算成本
  time: string; // 时间
  project_id: number | null; // 项目id
}

@Component({
  components: {
    AcgnPop
  }
})

/**
 * 修改预算价格
 */
export default class AcgnBubgetPriceEdit extends Vue {
  public name: string = 'AcgnBubgetPriceEdit';

  @Prop({ type: Object, default: {} }) private data: TargetEditType; // 数据
  @Prop({ type: Boolean, default: false }) private visible: boolean; // 控制dialog显示


  @StatisticAction private setProjectBudget: any; // 设定项目预算成本

  @StatisticGetter private loadings: any; // 章节loading
  @CommGetter private attributeData: any; // 公共类型

  private formData: TargetEditType = {
    num: 0,
    time: '', // 时间
    project_id: null, // 项目id
  };


  private get title() {
    return '《' + (this.data as any).name + '》预算成本';
  }
  private get show() {
    return this.visible;
  }
  private set show(v) {
    this.$emit('update:visible', v);
  }
  // 获取表单验证规则
  private get rules() {
    const rules = {
      num: [
        { required: true, message: '请输入预算成本', trigger: 'change' }
      ]
    };
    return rules;
  }

  private async created() {
    this.formData = { ...this.formData, ...(this.data as any).data };
  }

  // 收费设置提交
  private async submit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      try {
        const postData = complexClone(this.formData);
        await this.setProjectBudget(postData);
        this.$emit('change');
        this.$message.success('保存成功');
        this.show = false;
      } catch (ex) {
        this.$message.error(this.$language.error);
      }
    });
  }

  // 取消
  private close() {
    this.show = false;
  }
}
